import { Tab, Tabs } from '@material-ui/core'
import { assets } from '@pulseops/common'
import React from 'react'
import { View } from 'react-native'
import PDCreateAuthorizationLetter from './components/PDCreateAuthorizationLetter'
import PDManageAuthorizationLetter from './components/PDManageAuthorizationLetter'
import { Text } from 'react-native'

export default function PDAuthorizationLetterScreen() {
  const [value, setValue] = React.useState(0)

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue)
  }

  const a11yProps = (index: number) => {
    return {
      id: `authorization-letter-tab-${index}`,
      'aria-controls': `authorization-letter-tabpanel-${index}`
    }
  }

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Giấy ủy quyền</Text>
      <View>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="authorization letter tabs"
          TabIndicatorProps={{ style: { display: 'none' } }}
        >
          <Tab
            label={
              <span style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 6 }}>
                <assets.PDCreate style={{ color: value === 0 ? '#ED1B2E' : '#000' }} />
                Tạo Giấy ủy quyền
              </span>
            }
            {...a11yProps(0)}
            style={value === 0 ? styles.selectedTab : styles.unselectedTab}
            disableRipple
          />
          <Tab
            label={
              <span style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 6 }}>
                <assets.PDManage style={{ color: value === 1 ? '#ED1B2E' : '#000' }} />
                Quản lý Giấy ủy quyền
              </span>
            }
            {...a11yProps(1)}
            style={value === 1 ? styles.selectedTab : styles.unselectedTab}
            disableRipple
          />
        </Tabs>
        <View style={styles.wrapper}>
          {value === 0 ? (
            <PDCreateAuthorizationLetter styles={styles} />
          ) : (
            <PDManageAuthorizationLetter styles={styles} />
          )}
        </View>
      </View>
    </View>
  )
}

const styles: Record<string, any> = {
  container: {
    paddingTop: 0,
    paddingRight: 40,
    paddingBottom: 30,
    paddingLeft: 40,
    height: '100%',
    overflow: 'auto'
  },
  title: {
    fontSize: '24px',
    fontWeight: '600',
    marginBottom: '20px'
  },
  selectedTab: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    borderBottomWidth: 2,
    borderBottomStyle: 'solid',
    borderBottomColor: '#ED1B2E',
    paddingTop: 6,
    paddingRight: 20,
    paddingBottom: 6,
    paddingLeft: 20,
    color: '#ED1B2E',
    fontWeight: 'bold',
    minWidth: 'auto',
    minHeight: 'auto',
    textTransform: 'none' as const,
    backgroundColor: 'transparent'
  },
  unselectedTab: {
    paddingTop: 6,
    paddingRight: 20,
    paddingBottom: 6,
    paddingLeft: 20,
    color: '#000',
    minWidth: 'auto',
    minHeight: 'auto',
    textTransform: 'none' as const
  },
  wrapper: {
    backgroundColor: '#fff',
    borderRadius: '16px',
    padding: '20px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    marginTop: '20px',
    gap: 24
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 24,
    width: '100%'
  },
  column_1_4: {
    width: 'calc(100% / 4 - 18px)'
  },
  column_1_2: {
    width: 'calc(100% / 2 - 12px)'
  },
  submitButton: {
    backgroundColor: '#ED1B2E',
    color: '#fff',
    borderWidth: 0,
    paddingTop: 8,
    paddingRight: 16,
    paddingBottom: 8,
    paddingLeft: 16,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: 12,
    fontWeight: '600'
  },
  disabledButton: {
    backgroundColor: '#e5e7eb',
    color: '#9ca3af',
    borderWidth: 1,
    borderStyle: 'solid',
    borderColor: '#d1d5db',
    paddingTop: 8,
    paddingRight: 16,
    paddingBottom: 8,
    paddingLeft: 16,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    borderRadius: 12,
    fontWeight: '600',
    cursor: 'not-allowed',
    opacity: 0.7
  },
  mr_5: {
    marginRight: '5px'
  },
  subTitle: {
    fontSize: '18px',
    fontWeight: '700',
    whiteSpace: 'nowrap' as const
  },
  loadingOverlay: {
    position: 'fixed' as const,
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(255, 255, 255, 0.7)',
    zIndex: 2
  }
}
